import { useEffect, useState } from "react";

const target = new Date("2027-05-13T00:00:00").getTime();

export const Countdown = () => {
  const [tl, setTl] = useState(() => computeDiff());

  useEffect(() => {
    const t = setInterval(() => setTl(computeDiff()), 1000);
    return () => clearInterval(t);
  }, []);

  const colors = ["text-terracotta", "text-teal", "text-sage", "text-purple"];
  const box = (n, label, idx) => (
    <div className="flex flex-col items-center min-w-0 flex-1 sm:flex-none" data-testid={`countdown-${label.toLowerCase()}`}>
      <div className={`font-display text-[2.5rem] sm:text-5xl md:text-7xl font-black ${colors[idx]} tabular-nums leading-none drop-shadow-[0_3px_0_rgba(250,204,21,0.4)]`}>
        {String(n).padStart(2, "0")}
      </div>
      <div className="text-[9px] sm:text-[10px] md:text-xs tracking-[0.25em] sm:tracking-[0.35em] uppercase text-ink font-bold mt-2 md:mt-3">
        {label}
      </div>
    </div>
  );

  return (
    <div className="flex items-start justify-center gap-1 sm:gap-5 md:gap-10 px-2" data-testid="countdown">
      {box(tl.days, "Days", 0)}
      <span className="font-display text-3xl sm:text-4xl md:text-6xl text-gold mt-0 sm:mt-1 md:mt-2 font-black">·</span>
      {box(tl.hours, "Hours", 1)}
      <span className="font-display text-3xl sm:text-4xl md:text-6xl text-gold mt-0 sm:mt-1 md:mt-2 font-black">·</span>
      {box(tl.minutes, "Min", 2)}
      <span className="font-display text-3xl sm:text-4xl md:text-6xl text-gold mt-0 sm:mt-1 md:mt-2 font-black">·</span>
      {box(tl.seconds, "Sec", 3)}
    </div>
  );
};

function computeDiff() {
  const now = Date.now();
  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

export default Countdown;
